import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DigitalDistribution from '../components/DigitalDistribution';
import RightsManagement from '../components/RightsManagement';
import PartnersMarquee from '../components/PartnersMarquee';
import SuccessStories from '../components/SuccessStories';
import LabelsPartners from '../components/LabelsPartners';
import Footer from '../components/Footer';
import '../style.css';
import '../nov.css';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      title: "Protect Your Digital Music Rights",
      description: "Manage your copyrights, protect your content, and increase your revenue with Media Nov."
    },
    {
      title: "Get Your Music to the World",
      description: "Reach millions of listeners with our extensive distribution network."
    },
    {
      title: "Boost Your Success with Detailed Analytics",
      description: "Track your music performance with real-time data and optimize your strategy."
    }
  ];

  // Auto slide effect
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center bg-[#f5f5f7] px-6 lg:px-16 py-24 lg:py-32">
        <div className="max-w-[1400px] mx-auto text-center mt-8">
          <div className="relative overflow-visible mb-8">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`transition-all duration-1000 ease-in-out ${
                  index === currentSlide 
                    ? 'opacity-100 scale-100 block' 
                    : 'opacity-0 scale-95 absolute inset-0 pointer-events-none'
                }`}
              >
                <div className="space-y-8 py-8">
                  <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.2] tracking-tight uppercase animate-fade-in-up animation-delay-200 px-4" style={{ fontFamily: 'aesthet-nova' }}>
                    <span style={{ color: 'rgb(70, 52, 135)' }}>{slide.title}</span>
                  </h1>
                  <p className="text-lg md:text-xl lg:text-2xl font-light text-black leading-relaxed max-w-5xl mx-auto px-6" style={{ fontFamily: 'system-ui, Avenir, Helvetica, Arial, sans-serif' }}>
                    {slide.description}
                  </p>
                </div>
              </div>
            ))}
            
            {/* Slide indicators */}
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 flex gap-2 z-10">
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    index === currentSlide 
                      ? 'bg-gray-900 w-8' 
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                  aria-label={`Slide ${index + 1}`}
                />
              ))}
            </div>
          </div>

          <div className="mt-48 space-y-4">
            <div className="flex justify-center animate-fade-in-up animation-delay-400">
              <a 
                href="https://app.medianov.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-4 font-medium rounded-full transition-all duration-500 button-shimmer"
              >
                Content Manager - Login
              </a>
            </div>

            <div className="w-fit mx-auto animate-fade-in-up animation-delay-500">
              <div className="group relative flex max-w-fit flex-row items-center justify-center rounded-2xl px-4 py-1.5 text-sm font-medium badge-gradient text-gray-700 text-center">
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"/>
                </svg>
                Share Your Music to The World
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Digital Distribution Section */}
      <DigitalDistribution />

      {/* Rights Management Section */}
      <RightsManagement />

      {/* Partners Marquee Section */}
      <PartnersMarquee />

      {/* Success Stories Section */}
      <SuccessStories />

      {/* Labels Partners Section */}
      <LabelsPartners />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Home;
